export default {
  // Tabs
  'webConfig.tabs.login': 'Login & Register Config',
  'webConfig.tabs.thirdParty': 'Third Party Login Config',
  'webConfig.tabs.appManage': 'App Management',
  'webConfig.tabs.livechat': 'Livechat Settings',
  'webConfig.tabs.otherConfig': 'Other Configurations',
  'webConfig.tabs.reportConfig': 'Regulatory Reporting',

  // Regulatory Reporting Config
  'webConfig.reportConfig.title': 'Reporting Ratio',
  'webConfig.reportConfig.tip': 'Applies only to newly registered users; existing users\' report_status is unaffected. Effective immediately after saving.',
  'webConfig.reportConfig.currentRatio': 'Current ratio',
  'webConfig.reportConfig.report': '(Route A)',
  'webConfig.reportConfig.notReport': '(Route B)',
  'webConfig.reportConfig.lastModify': 'Last modified by',
  'webConfig.reportConfig.version': 'Version',
  'webConfig.reportConfig.adjustTo': 'Adjust to',
  'webConfig.reportConfig.save': 'Save',
  'webConfig.reportConfig.historyTitle': 'Recent 10 changes',
  'webConfig.reportConfig.col.version': 'Version',
  'webConfig.reportConfig.col.time': 'Time',
  'webConfig.reportConfig.col.operator': 'Operator',
  'webConfig.reportConfig.col.change': 'Old → New',
  'webConfig.reportConfig.col.reason': 'Reason',
  'webConfig.reportConfig.confirmTitle': 'Confirm ratio change',
  'webConfig.reportConfig.confirmContent': 'Adjust reporting ratio to {{ratio}}%? Effective immediately.',
  'webConfig.reportConfig.reasonPh': 'Change reason (optional, for audit)',
  'webConfig.reportConfig.saveSuccess': 'Saved',
  'webConfig.reportConfig.saveFail': 'Save failed',
  'webConfig.reportConfig.fetchError': 'Failed to load',
  'webConfig.reportConfig.invalidRatio': 'Please enter an integer 0~100',

  // Game route auto-upgrade strategy
  'webConfig.routeStrategy.title': 'Game Route Strategy',
  'webConfig.routeStrategy.tip': 'New users default to Route B and are upgraded one-way to Route A once a threshold is met (irreversible). Both strategies can coexist (meet either to upgrade); members who were switched manually are no longer affected by auto strategies.',
  'webConfig.routeStrategy.strategyTitle': 'Enable strategies',
  'webConfig.routeStrategy.depositStrategy': 'By cumulative deposit threshold',
  'webConfig.routeStrategy.vipStrategy': 'By VIP level',
  'webConfig.routeStrategy.vipLevelLabel': 'Upgrade VIP level',
  'webConfig.routeStrategy.addCurrency': 'Add currency',
  'webConfig.routeStrategy.remove': 'Remove',
  'webConfig.routeStrategy.save': 'Save',
  'webConfig.routeStrategy.col.currency': 'Currency',
  'webConfig.routeStrategy.col.amount': 'Threshold',
  'webConfig.routeStrategy.col.enabled': 'Enabled',
  'webConfig.routeStrategy.col.action': 'Action',
  'webConfig.routeStrategy.saveSuccess': 'Saved successfully',
  'webConfig.routeStrategy.saveFail': 'Save failed',
  'webConfig.routeStrategy.fetchError': 'Load failed',
  'webConfig.routeStrategy.thresholdInvalid': 'Enabled currency thresholds require currency and amount',
  'webConfig.routeStrategy.currencyDuplicate': 'Currency cannot be duplicated',
  'webConfig.routeStrategy.vipLevelRequired': 'Please enter the upgrade VIP level',

  // Login Register Config
  'webConfig.login.inviteCode': 'Invitation Code',
  'webConfig.login.inviteCodeRequired': 'Invitation Code Required:',
  'webConfig.login.outletSelection': 'Outlet Selection',
  'webConfig.login.agreementManualCheck': 'Registration PAGCOR Terms Checkbox',
  'webConfig.login.rgPopupBeforeLogin': 'Responsible Gaming Popup (Before Login)',
  'webConfig.login.rgPopupAfterLogin': 'Responsible Gaming Popup (After Login)',
  'webConfig.login.passwordRisk': 'Login Password Risk Control',
  'webConfig.login.passwordRiskMinutes': 'minutes after',
  'webConfig.login.passwordRiskTimes': 'failed attempts',
  'webConfig.login.identityInfo': 'Identity Information:',
  'webConfig.login.phoneOtp': 'Phone OTP Verification:',
  'webConfig.login.emailOtp': 'Email OTP Verification:',
  'webConfig.login.isRegKaptcha': 'Register Captcha Verification:',
  'webConfig.login.isRegisterMobileOTP': 'Registration OTP switch:',
  'webConfig.login.isBindBankOTP': 'Bind Withdrawal Account OTP:',
  'webConfig.login.registerCaptcha': 'Register Captcha Type:',
  'webConfig.login.captchaType': 'Captcha Type:',
  'webConfig.login.isLoginKaptcha': 'Login Captcha Verification:',
  'webConfig.login.loginCaptcha': 'Login Captcha Type:',
  'webConfig.login.isForgetPassKaptcha': 'Forgot password verification code switch:',
  'webConfig.login.forgetKaptchaType': 'Forgot password verification code type:',
  'webConfig.login.isStrongPassword': 'Strong password switch:',
  'webConfig.login.memberPasswordRule': 'Member password verification rule:',
  'webConfig.login.isMultipleDeviceLogin': 'Multiple device login switch:',
  'webConfig.login.captcha.ziyan': 'Self-developed Captcha',
  'webConfig.login.captcha.yidun': 'Yidun Captcha',
  'webConfig.login.captcha.cloudfare': 'cloudfare Captcha',
  'webConfig.login.masterCaptcha': 'Captcha Master Switch:',
  'webConfig.login.masterCaptchaType': 'Captcha Type:',
  'webConfig.login.applicablePages': 'Applicable Pages:',
  'webConfig.login.configurePages': 'Configure Pages',
  'webConfig.login.page.login': 'Login Page Captcha',
  'webConfig.login.page.forgot': 'Forgot Password Captcha',
  'webConfig.login.page.register': 'Register Page Captcha',
  'webConfig.login.page.bindPhone': 'Bind Phone',
  'webConfig.login.page.bindEmail': 'Bind Email',
  'webConfig.login.page.bindWithdraw': 'Bind Withdrawal Account',
  'webConfig.login.page.kioskQuery': 'Kiosk Account & Password Query',
  'webConfig.login.masterCaptchaHint': 'When enabled, the client checks if the current page is in the applicable pages list. If matched, a captcha popup appears before sending verification codes. Verification must pass before codes are sent. If not matched or master switch is off, the original flow proceeds.',
  'webConfig.login.atLeastOnePage': 'Please select at least one applicable page',
  'webConfig.login.noPageConfigured': 'No pages configured, captcha will not take effect',
  'webConfig.login.changePassword': 'Change Password:',
  'webConfig.login.changePassword.phone': 'Phone OTP Verification',
  'webConfig.login.changePassword.email': 'Email OTP Verification',
  'webConfig.login.mobileLoginBg': 'Mobile Login Background:',
  'webConfig.login.mobileRegisterBg': 'Mobile Register Background:',
  'webConfig.login.pcLoginBg': 'PC Login Background:',
  'webConfig.login.pcRegisterBg': 'PC Register Background:',
  'webConfig.login.deviceLimit': 'Same Device Registration Limit (Switch):',
  'webConfig.login.deviceLimitTime': 'Statistics Period (Hours):',
  'webConfig.login.deviceNum': 'Allowed Registration Count:',
  'webConfig.login.ipLimit': 'Same IP Registration Limit (Switch):',
  'webConfig.login.ipLimitTime': 'Statistics Period (Hours):',
  'webConfig.login.ipLimitNum': 'Allowed Registration Count:',
  'webConfig.login.save': 'Save',
  'webConfig.login.phoneBind': 'Phone Binding',
  'webConfig.login.emailBind': 'Email Binding',
  'webConfig.login.allowSkip': 'Allow Skip',

  // Third Party Config
  'webConfig.thirdParty.google': 'Google Login:',
  'webConfig.thirdParty.facebook': 'Facebook Login:',
  'webConfig.thirdParty.manualCreate': 'Third-Party Login Mobile Verification:',
  'webConfig.thirdParty.googleClientId': 'Google Client ID:',
  'webConfig.thirdParty.googleAndroidClientId': 'Google Android App Client ID:',
  'webConfig.thirdParty.googleIosClientId': 'Google iOS Client ID:',
  'webConfig.thirdParty.googleLoginUrl': 'Google Login URL:',
  'webConfig.thirdParty.facebookAppId': 'Facebook App ID:',
  'webConfig.thirdParty.facebookAppSecret': 'Facebook App Secret:',
  'webConfig.thirdParty.facebookLoginUrl': 'Facebook Login URL:',
  'webConfig.thirdParty.appleAppClientId': 'Apple iOS Bundle ID:',

  // App Management
  'webConfig.app.channel': 'Channel',
  'webConfig.app.appType': 'App Type',
  'webConfig.app.forceUpgrade': 'Force Upgrade',
  'webConfig.app.version': 'Version',
  'webConfig.app.downloadUrl': 'Download URL',
  'webConfig.app.status': 'Status',
  'webConfig.app.status.enabled': 'Enabled',
  'webConfig.app.status.disabled': 'Disabled',
  'webConfig.app.actions': 'Actions',
  'webConfig.app.edit': 'Edit',
  'webConfig.app.delete': 'Delete',
  'webConfig.app.disable': 'Disable',
  'webConfig.app.enable': 'Enable',
  'webConfig.app.editTitle': 'Edit App Configuration',
  'webConfig.app.downloadSettings': 'App Download Settings',
  'webConfig.app.cancel': 'Cancel',
  'webConfig.app.confirm': 'Confirm',

  // Livechat Config
  'webConfig.livechat.clientId': 'LiveChat Client ID:',
  'webConfig.livechat.grantType': 'LiveChat Grant Type:',
  'webConfig.livechat.licenseId': 'LiveChat License ID:',
  'webConfig.livechat.responseType': 'LiveChat Response Type:',
  'webConfig.livechat.redirectUrl': 'LiveChat Redirect URL:',
  'webConfig.livechat.backupUrl': 'Customer Service Backup URL:',

  // SEO - Google Search Console
  'webConfig.tabs.gsc': 'Google Search Console (SEO Index Stats)',
  'webConfig.gsc.siteUrl': 'GSC Site Property:',
  'webConfig.gsc.siteUrlDesc': 'Search Console property, e.g. sc-domain:example.com or https://example.com/',
  'webConfig.gsc.siteBaseUrl': 'SEO Site Base URL:',
  'webConfig.gsc.siteBaseUrlDesc': 'The site origin where article pages actually live, used to build absolute URLs for the sitemap and index checks. Required when the GSC property above is a domain (e.g. sc-domain:example.com) but articles are on a subdomain (e.g. https://www.example.com). Leave empty to fall back to the GSC Site Property.',
  'webConfig.gsc.serviceAccountJson': 'GSC Service Account JSON:',
  'webConfig.gsc.serviceAccountJsonPlaceholder': 'Paste the entire service-account .json file downloaded from Google Cloud as-is (do not hand-edit). e.g. { "type": "service_account", "project_id": "...", "private_key": "...", "client_email": "xxx@xxx.iam.gserviceaccount.com", ... }',
  'webConfig.gsc.serviceAccountJsonDesc': 'Paste the full Google service-account key JSON. The service account must be added as a user of this property in Search Console. Leave empty and "Indexed / Excluded" will show "-".',
  'webConfig.gsc.syncBatchSize': 'Pages per sync:',
  'webConfig.gsc.syncBatchSizeDesc': 'Max pages each scheduled run inspects (incremental, least-recently-synced first). Bound by GSC quota (2000/day): this value × runs-per-day should be ≤ 2000. For every-15-min (96 runs/day), keep ≤ 20. Empty = default 20; 0 = all pages (use with care).',

  // Other Config
  'webConfig.other.pointExpire': 'Points Expiration:',
  'webConfig.other.adminGoogleAuth': 'Admin Google Authenticator:',
  'webConfig.other.kycProcess': 'KYC Verification Process:',
  'webConfig.other.kycAutoApprove': 'KYC Auto-Approval:',
  'webConfig.other.kycRegisterForce': 'Register for mandatory KYC certification:',
  'webConfig.other.KycSimplify': 'Registration KYC:',
  'webConfig.other.kycRegisterWithdraw': 'Withdrawal KYC:',
  'webConfig.other.KycAgent': 'Agent Skip Registration KYC:',
  'webConfig.other.isOpenBlackList': 'BlackList Check KYC:',
  'webConfig.other.kycWithDrawAgent': 'Agent Skip Withdrawal KYC:',
  'webConfig.other.KycInterceptorsPath': 'KYC interception path:',
  'webConfig.other.withdrawKYCVerifyDateNum': 'Withdrawal KYC failure validity period:',
  'webConfig.other.withdrawKYCVerifyTimes': 'Withdrawal KYC reminder times:',
  'webConfig.other.withdrawKYCInterceptorsPath': 'Withdrawal KYC failure interception path:',
  'webConfig.other.adminLogo': 'Admin Logo URL:',
  'webConfig.other.vapeSafeMode': 'Vape Safe Mode:',
  'webConfig.other.imageUrl': 'Image Access URL:',
  'webConfig.other.gameImageUrl': 'Game Image Access URL:',
  'webConfig.other.payCallbackDomain': 'Payment Callback Domain:',
  'webConfig.other.allowedCountries': 'Frontend Allowed Countries:',
  'webConfig.other.vipMaxLevel': 'VIP Max Level Display',
  'webConfig.other.vipMaxLevelDesc': 'Controls the number of VIP levels displayed on the frontend. Please make sure to set the growth value of the selected level to infinity.',
  'webConfig.other.vipRewardWeeklyPayoutDay': 'VIP weekly salary payout date',
  'webConfig.other.vipRewardWeeklyPayoutDayDesc': 'Supports numbers 1-7 (Monday = 1), English MONDAY..SUNDAY',
  'webConfig.other.vipRewardWeeklyWindowDays': 'VIP weekly salary statistics days',
  'webConfig.other.rtpRange': 'RTP Display Range',
  'webConfig.other.appDownloadLandingPage': 'App Download Landing Page URL:',
  'webConfig.other.appAndroidDownloadLandingPage': 'App Android Download Landing Page URL:',
  'webConfig.other.appAndroidVersion': 'App Android version number:',
  'webConfig.other.appAndroidForceUpdate': 'App Android forced update:',
  'webConfig.other.activeUserAgent': 'Active User Agent:',
  'webConfig.other.activeUserAgentPlaceholder': 'Please select active user agent',
  'webConfig.other.indexLoading': 'Boot Animation:',
  'webConfig.other.balanceLimit.title': 'Account Information - Manual Adjustment',
  'webConfig.other.balanceLimit.addMax': 'Increase Amount Limit:',
  'webConfig.other.balanceLimit.addMaxPlaceholder': 'Please enter increase amount limit',
  'webConfig.other.balanceLimit.reduceMax': 'Decrease Amount Limit:',
  'webConfig.other.balanceLimit.reduceMaxPlaceholder': 'Please enter decrease amount limit',
  'webConfig.other.balanceLimit.numberRule': 'Please enter a number greater than 1',
  'webConfig.other.nonNegativeNumberRule': 'Please enter a number greater than or equal to 0',
  'webConfig.other.pointLimit.title': 'Member Points - Manual Point Adjustment',
  'webConfig.other.pointLimit.addMax': 'Increase Member Points Limit:',
  'webConfig.other.pointLimit.addMaxPlaceholder': 'Please enter increase member points limit',
  'webConfig.other.pointLimit.reduceMax': 'Decrease Member Points Limit:',
  'webConfig.other.pointLimit.reduceMaxPlaceholder': 'Please enter decrease member points limit',
  'webConfig.other.pointLimit.numberRule': 'Please enter a number greater than 1',
  'webConfig.other.opUserAgentAllocLimit.title': 'Backend Account → Agent Per-Transaction Allocation Limit',
  'webConfig.other.opUserAgentAllocLimit.desc': 'Controls the per-transaction limit when a backend account allocates quota to a L1 or L2 agent (PHP / VND / CNY independent)',
  'webConfig.other.opUserAgentAllocLimit.addMax': 'Per-Transaction Increase Limit:',
  'webConfig.other.opUserAgentAllocLimit.addMaxPlaceholder': 'Please enter per-transaction increase limit',
  'webConfig.other.opUserAgentAllocLimit.reduceMax': 'Per-Transaction Decrease Limit:',
  'webConfig.other.opUserAgentAllocLimit.reduceMaxPlaceholder': 'Please enter per-transaction decrease limit',
  'webConfig.other.agentAllocLimit.title': 'Agent Allocation Limit',
  'webConfig.other.agentAllocLimit.desc': 'Controls the per-transaction limit when a L1 agent allocates quota to a L2 agent (applies to "Adjustment Quota" target only)',
  'webConfig.other.agentAllocLimit.addMax': 'Per-Transaction Increase Limit:',
  'webConfig.other.agentAllocLimit.addMaxPlaceholder': 'Please enter per-transaction increase limit',
  'webConfig.other.agentAllocLimit.reduceMax': 'Per-Transaction Decrease Limit:',
  'webConfig.other.agentAllocLimit.reduceMaxPlaceholder': 'Please enter per-transaction decrease limit',

  // Common
  'webConfig.common.yes': 'Yes',
  'webConfig.common.no': 'No',
  'webConfig.common.saveSuccess': 'Saved successfully',
  'webConfig.common.saveFailed': 'Save failed',
  'webConfig.common.updateSuccess': 'Updated successfully',
  'webConfig.common.updateFailed': 'Update failed',
  'webConfig.common.disableSuccess': 'Disabled successfully',
  'webConfig.common.disableFailed': 'Disable failed',
  'webConfig.common.enableSuccess': 'Enabled successfully',
  'webConfig.common.enableFailed': 'Enable failed',
  'webConfig.common.deleteSuccess': 'Deleted successfully',
  'webConfig.common.deleteFailed': 'Delete failed',
  'sys.enterCorrectEmail': 'Please enter a valid email address',

  // Dictionary item labels: key = dict.<groupCode>.<itemCode> (language-neutral codes from dict_group_item).
  // Shared across modules. Never display the backend item_name / item_name_en directly.
  // 21005 app type
  'dict.21005.21005001': 'iOS',
  'dict.21005.21005002': 'Android',
  // 21006 app channel
  'dict.21006.21006001': 'Super Sign',
  'dict.21006.21006002': 'App Store',
  'dict.21006.21006003': 'Google Play',
  'dict.21006.21006004': 'XIAOMI Store',
  'dict.21006.21006005': 'CHUANYIN Store',
  'dict.21006.21006006': 'VIVO',
  'dict.21006.21006007': 'OPPO',
  'dict.21006.21006008': 'Huawei',
  // 80002 email type / email format
  'dict.80002.80002001': 'Microsoft Email',
  'dict.80002.80002002': 'Google Email',
  'dict.80002.80002003': 'mailgun',
  // 80003 email business type
  'dict.80003.80003001': 'Send Verification Code',
};
